// No redirect + increment cart icon + change button text to "Added"
(() => {
  // ---------- helpers ----------
  const getQtyFromForm = (form) => {
    const q = form.querySelector('[name="quantity"]');
    const n = parseInt(q?.value || '1', 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  };

  const findCountEl = () =>
    document.querySelector('[data-cart-count]') ||
    document.querySelector('.cart-count-bubble') ||
    document.querySelector('[aria-label="Cart count"]') ||
    document.querySelector('.header__cart-count') ||
    null;

  const readCount = (el) => {
    const n = parseInt((el?.textContent || '').replace(/\D+/g, ''), 10);
    return Number.isFinite(n) ? n : 0;
  };

  const setCount = (el, n) => {
    if (!el) return;
    el.textContent = n;
    el.setAttribute?.('aria-live', 'polite');
    el.classList?.add('cart-count-bump');
    setTimeout(() => el.classList?.remove('cart-count-bump'), 400);
  };

  const optimisticIncrement = (qty) => {
    const el = findCountEl();
    if (!el) return;
    setCount(el, readCount(el) + qty);
  };

  const reconcileCount = async () => {
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const el = findCountEl();
      if (el) setCount(el, cart.item_count || 0);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch (e) {
      console.debug('[ATC] reconcile failed', e);
    }
  };

  // ----- button text helpers -----
  const getBtnLabelNode = (btn) =>
    btn?.querySelector?.('[data-default-text], .text, .button__text, .btn__text, span') || btn;

  const flashButton = (btn, okText = 'Added', ms = 1600) => {
    if (!btn) return;
    const label = getBtnLabelNode(btn);
    const original = btn.dataset.originalText || label.textContent.trim();
    btn.dataset.originalText = original;

    btn.disabled = true;
    label.textContent = okText;
    btn.classList.add('is-added');

    setTimeout(() => {
      label.textContent = btn.dataset.originalText || original;
      btn.disabled = false;
      btn.classList.remove('is-added');
    }, ms);
  };

  // ----- block redirects to /cart during add -----
  const temporarilyBlockCartRedirects = (ms = 3000) => {
    const origAssign = window.location.assign.bind(window.location);
    const origReplace = window.location.replace.bind(window.location);
    const guard = (fn) => (url) => {
      if (typeof url === 'string' && /\/cart(\/|\?|$)/.test(url)) return;
      return fn(url);
    };
    window.location.assign = guard(origAssign);
    window.location.replace = guard(origReplace);

    const desc = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
    if (desc?.set) {
      const realSet = desc.set;
      Object.defineProperty(window.location, 'href', {
        configurable: true,
        set(v) {
          if (typeof v === 'string' && /\/cart(\/|\?|$)/.test(v)) return;
          realSet.call(window.location, v);
        },
      });
    }
    setTimeout(() => {
      window.location.assign = origAssign;
      window.location.replace = origReplace;
    }, ms);
  };

  // ----- bind product forms -----
  const bindForm = (form) => {
    if (form.__noRedirectBound) return;
    form.__noRedirectBound = true;

    form.addEventListener('submit', async (e) => {
      const isCartAdd =
        (form.getAttribute('action') || '').endsWith('/cart/add') ||
        (form.action || '').endsWith('/cart/add');
      if (!isCartAdd) return;

      e.preventDefault();
      temporarilyBlockCartRedirects(3000);

      const qty = getQtyFromForm(form);
      const btn =
        form.querySelector('[type="submit"], button[name="add"], .product-form__submit, button.add-to-cart');

      try {
        // add to cart (AJAX)
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!res.ok) throw new Error('Add to cart failed');

        // 1) instant feedback
        optimisticIncrement(qty);
        flashButton(btn, 'Added', 1500);

        // 2) optional: open drawer briefly
        // document.documentElement.classList.add('cart-drawer-open');
        // setTimeout(() => document.documentElement.classList.remove('cart-drawer-open'), 1400);

        // 3) reconcile with true count
        reconcileCount();
      } catch (err) {
        console.error('[ATC] add error', err);
        // form.submit(); // enable if you want fallback on error
      }
    }, true);
  };

  // bind existing & future forms
  document.querySelectorAll('form[action="/cart/add"]').forEach(bindForm);
  new MutationObserver((muts) => {
    for (const m of muts) {
      for (const node of m.addedNodes || []) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('form[action="/cart/add"]')) bindForm(node);
        node.querySelectorAll?.('form[action="/cart/add"]').forEach(bindForm);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
